import React from 'react';
import { SAUDI } from '../../data/content';
import SectionHeader from '../SectionHeader';
import Callout from '../Callout';
import { useIntersection } from '../../hooks/useIntersection';

const pilotColors = [
  { bg: 'var(--gpale)', border: '1px solid var(--g2)', textColor: 'var(--g2)', subColor: 'var(--gray)' },
  { bg: 'var(--gpale)', border: '1px solid var(--g2)', textColor: 'var(--g2)', subColor: 'var(--gray)' },
  { bg: 'var(--g2)',    border: '1px solid var(--g2)', textColor: '#fff',       subColor: 'rgba(255,255,255,0.65)' },
  { bg: '#111827',      border: '1px solid #111827',   textColor: '#fff',       subColor: 'var(--g5)' },
];

export default function Saudi() {
  const { ref, visible } = useIntersection();
  return (
    <section id="saudi" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={SAUDI.sectionNum} title={SAUDI.title} titleEm={SAUDI.titleEm} body={SAUDI.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
          <div className="r25-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 24 }}>
            {SAUDI.pilot.map((p, i) => {
              const c = pilotColors[i];
              return (
                <div key={i} style={{ background: c.bg, border: c.border, borderRadius: 8, padding: '20px 16px', textAlign: 'center' }}>
                  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', color: c.subColor, marginBottom: 6 }}>{p.month}</div>
                  <div style={{ fontFamily: 'var(--serif)', fontSize: 24, fontWeight: 600, color: c.textColor, marginBottom: 4 }}>{p.rev}</div>
                  <div style={{ fontSize: 11, color: c.subColor }}>{p.note}</div>
                </div>
              );
            })}
          </div>
          <Callout title={SAUDI.callout.title}>{SAUDI.callout.body}</Callout>
        </div>
      </div>
    </section>
  );
}
